/**
 * This file is auto-generated by 'scripts/generate-slot-metadata.ts' from '@eneco/cms-sanity-schema'
 * (lib/containerSlots.ts, lib/pageAreas.ts, inputs/page-builder.ts) and 'libs/cms-sanity/schema.json'. Do not manually edit;
 * your changes might get lost.
 */
import type { SlotMetadata } from './slot-metadata';

export const SLOT_METADATA: SlotMetadata = {
  containers: {
    AdvancePaymentAmount: [
      {
        area: 'jss-advance-payment-amount-right',
        label: 'Advance payment amount right',
        types: ['ChatEntryPoint', 'QuickLinks'],
      },
    ],
    Article: [
      {
        area: 'jss-article-main',
        label: 'Article main',
        types: [
          'Article',
          'ContentCard',
          'FlourishChart',
          'GenericForm',
          'Image',
          'ShareOnSocials',
          'StoreButtons',
          'Table',
          'TextStreamer',
          'TitleTextCTA',
          'Video',
        ],
      },
    ],
    B2BLeadFlowThankYouStep: [
      { area: 'jss-b2b-lead-flow-step-explainer', label: 'B2b lead flow step explainer', types: [] },
    ],
    ButtonLineUp: [{ area: 'jss-buttons', label: 'Buttons', types: ['ButtonLink'] }],
    Carousel: [
      {
        area: 'jss-carousel-main',
        label: 'Carousel main',
        types: [
          'ContentCard',
          'ContentCardRebranded',
          'Image',
          'WeDoenHetNuTestimonialsCard',
          'WieDoetErMeeContentCard',
        ],
      },
    ],
    Centered: [
      {
        area: 'jss-centered-main',
        label: 'Centered main',
        types: [
          'Accordion',
          'ContactForm',
          'DeceasedForm',
          'FeaturePreview',
          'GenericForm',
          'HeatDamageForm',
          'HeatPumpSpecTable',
          'IDealPaymentV2',
          'Image',
          'LinkCard',
          'NewsletterFormIntegratedWithRevolution',
          'PersonalizedVideo',
          'RegisterToNewsletterForm',
          'RevolutionForm',
          'RevolutionRegisterToNewsletterForm',
          'ShareOnSocials',
          'SimpleTable',
          'StoreButtons',
          'Table',
          'TitleTextCTA',
          'UsabillaFeedback',
          'Video',
          'WarmthInterruptions',
        ],
      },
    ],
    ContentCard: [
      { area: 'jss-content-card-main', label: 'Content card main', types: ['Divider', 'IconList', 'Price'] },
      { area: 'jss-promo-box', label: 'Promo box', types: [] },
    ],
    ContentCardRebranded: [{ area: 'jss-promo-box', label: 'Promo box', types: [] }],
    ContentHubFilter: [
      { area: 'jss-content-hub-filter-introduction', label: 'Content hub filter introduction', types: [] },
    ],
    DashboardV2: [
      {
        area: 'jss-dashboard-cards',
        label: 'Dashboard cards',
        types: [
          'AccountCard',
          'AdvancePaymentAmountCard',
          'ContractRenewedCard',
          'DynamicPriceCardElectricityV2',
          'DynamicPriceCardGasV2',
          'HomeProfileCard',
          'IntroductionCard',
          'InvoicesCard',
          'MandateCard',
          'MeterInErrorCard',
          'MeterreadingsCard',
          'PaymentPlanCard',
          'PromotionCard',
          'RelocationCard',
          'ServiceLinksCard',
          'UsageCard',
        ],
      },
      {
        area: 'jss-dashboard-cards-featured',
        label: 'Dashboard cards featured',
        types: [
          'AccountCard',
          'AdvancePaymentAmountCard',
          'DynamicPriceCardElectricityV2',
          'DynamicPriceCardGasV2',
          'HomeProfileCard',
          'IntroductionCard',
          'InvoicesCard',
          'MandateCard',
          'MeterInErrorCard',
          'MeterreadingsCard',
          'PaymentPlanCard',
          'PromotionCard',
          'RelocationCard',
          'ServiceLinksCard',
          'UsageCard',
        ],
      },
    ],
    DynamicPricingTariffs: [
      {
        area: 'jss-graph-cards',
        label: 'Graph cards',
        types: ['DynamicPriceCardElectricityV2', 'DynamicPriceCardGasV2'],
      },
    ],
    EloquaForm: [{ area: 'jss-eloqua-form', label: 'Eloqua form', types: [] }],
    Footer: [
      { area: 'jss-footer-navigation', label: 'Footer navigation', types: ['FooterMenu'] },
      { area: 'jss-subfooter-left', label: 'Subfooter left', types: ['SubFooterMenu'] },
      { area: 'jss-subfooter-right', label: 'Subfooter right', types: ['SocialMediaMenu'] },
    ],
    GenericForm: [
      {
        area: 'jss-form',
        label: 'Form',
        types: [
          'GenericFormAddressField',
          'GenericFormCheckboxField',
          'GenericFormCheckboxGroup',
          'GenericFormCheckboxWithValueField',
          'GenericFormDateField',
          'GenericFormDivider',
          'GenericFormEmailInputField',
          'GenericFormHiddenConfigurationValueField',
          'GenericFormInputField',
          'GenericFormInputHiddenField',
          'GenericFormInputSelect',
          'GenericFormKVKFinderField',
          'GenericFormNameField',
          'GenericFormNumberInputField',
          'GenericFormParagraph',
          'GenericFormPhoneNumberInputField',
          'GenericFormRadioGroup',
          'GenericFormSalutationField',
          'GenericFormTextAreaInputField',
          'GenericFormUsageField',
        ],
      },
    ],
    Hero: [
      { area: 'jss-hero-bottom', label: 'Hero bottom', types: ['TopTaskCTA', 'TopTasks'] },
      {
        area: 'jss-hero-left',
        label: 'Hero left',
        types: [
          'AdvancedCalculationTool',
          'ChatLinks',
          'HeroCard',
          'HeroCardRebranded',
          'Image',
          'PersonalizedTitleTextCTA',
          'SmartHomeBattery',
          'TitleTextCTA',
          'WarmthCheckAddressFinder',
          'WeDoenHetNuCard',
          'WieDoetErMeeContentCard',
        ],
      },
      {
        area: 'jss-hero-right',
        label: 'Hero right',
        types: [
          'AdvancedCalculationTool',
          'AffiliateCalculationTool',
          'HeroCard',
          'Image',
          'TitleTextCTA',
          'Video',
          'WarmthCheckAddressFinder',
        ],
      },
    ],
    HeroCard: [
      {
        area: 'jss-hero-card-main',
        label: 'Hero card main',
        types: [
          'AddressFinder',
          'AddressFinderWithMovingOption',
          'AdvancedCalculationTool',
          'AffiliateCalculationTool',
          'ButtonLineUp',
          'HeatComparisonTool',
          'PaymentMethods',
          'SmeAddressFinder',
        ],
      },
      { area: 'jss-hero-card-top', label: 'Hero card top', types: [] },
    ],
    HeroCardRebranded: [
      {
        area: 'jss-hero-card-main',
        label: 'Hero card main',
        types: [
          'AddressFinder',
          'AddressFinderWithMovingOption',
          'AdvancedCalculationTool',
          'AffiliateCalculationTool',
          'ButtonLineUp',
          'HeatComparisonTool',
          'PaymentMethods',
          'SmeAddressFinder',
        ],
      },
    ],
    HeroRebranded: [
      { area: 'jss-hero-bottom', label: 'Hero bottom', types: ['TopTaskCTA', 'TopTasks'] },
      {
        area: 'jss-hero-left',
        label: 'Hero left',
        types: [
          'AdvancedCalculationTool',
          'ChatLinks',
          'HeroCard',
          'HeroCardRebranded',
          'Image',
          'PersonalizedTitleTextCTA',
          'SmartHomeBattery',
          'TitleTextCTA',
          'WarmthCheckAddressFinder',
          'WeDoenHetNuCard',
          'WieDoetErMeeContentCard',
        ],
      },
      { area: 'jss-promo-box', label: 'Promo box', types: [] },
    ],
    LineUp: [
      {
        area: 'jss-line-up-main',
        label: 'Line up main',
        types: ['ContentCard', 'ContentCardRebranded', 'WeDoenHetNuTestimonialsCard', 'WieDoetErMeeContentCard'],
      },
      { area: 'jss-usp-line-up-main', label: 'Usp line up main', types: ['USPItem'] },
    ],
    MainNavigation: [
      { area: 'jss-header-lang', label: 'Header lang', types: ['LanguageSelector'] },
      { area: 'jss-logo', label: 'Logo', types: ['Logo'] },
      { area: 'jss-main-navigation-breadcrumbs', label: 'Main navigation breadcrumbs', types: ['BreadCrumbs'] },
      {
        area: 'jss-main-navigation-left',
        label: 'Main navigation left',
        types: ['MainMenu', 'MegaMenu', 'MegaMenuV2'],
      },
      {
        area: 'jss-main-navigation-right',
        label: 'Main navigation right',
        types: ['LoginMenu', 'MainMenu', 'SearchChatBot'],
      },
      { area: 'jss-secondary-navigation', label: 'Secondary navigation', types: ['SubMenu'] },
      { area: 'jss-side-navigation', label: 'Side navigation', types: ['ProfileMenu'] },
      { area: 'jss-topheader', label: 'Top header', types: ['TopMenu'] },
    ],
    MegaMenu: [{ area: 'jss-megamenu-divisions', label: 'Megamenu divisions', types: ['MegaMenuDivision'] }],
    MegaMenuDivision: [{ area: 'jss-megamenu-division-cards', label: 'Megamenu division cards', types: [] }],
    MegaMenuV2: [{ area: 'jss-megamenu-divisions', label: 'Megamenu divisions', types: [] }],
    MyEnvDisabledLandingPageCard: [
      { area: 'jss-my-env-blocked-main', label: 'My env blocked main', types: ['StoreButtons'] },
    ],
    NavigationView: [
      { area: 'jss-navigation-view-first', label: 'Navigation view first', types: ['StickyNav'] },
      {
        area: 'jss-navigation-view-second',
        label: 'Navigation view second',
        types: ['Accordion', 'Image', 'List', 'StoreButtons', 'TitleTextCTA', 'Video'],
      },
    ],
    NewsletterFormIntegratedWithRevolution: [
      { area: 'jss-newsletter-form-error', label: 'Newsletter form error', types: ['TitleTextCTA'] },
      { area: 'jss-newsletter-form-intro', label: 'Newsletter form intro', types: ['TitleTextCTA'] },
      { area: 'jss-newsletter-form-success', label: 'Newsletter form success', types: ['TitleTextCTA'] },
    ],
    OrderManagement: [{ area: 'jss-navigation-flow-be', label: 'Navigation flow be', types: [] }],
    PriceSimulation: [{ area: 'jss-navigation-flow-be', label: 'Navigation flow be', types: [] }],
    ProductsV2: [{ area: 'jss-products-top', label: 'Products top', types: ['ContractRenewedCard'] }],
    ProjectOverview: [{ area: 'jss-ecconova-filters', label: 'Ecconova filters', types: [] }],
    RealtimeContent: [{ area: 'jss-realtime-content', label: 'Realtime content', types: [] }],
    RegisterToNewsletterForm: [
      { area: 'jss-newsletter-form-error', label: 'Newsletter form error', types: ['TitleTextCTA'] },
      { area: 'jss-newsletter-form-intro', label: 'Newsletter form intro', types: ['TitleTextCTA'] },
      { area: 'jss-newsletter-form-success', label: 'Newsletter form success', types: ['TitleTextCTA'] },
    ],
    RegistrationAccountCreate: [
      { area: 'jss-registration-bottom', label: 'Registration bottom', types: ['ContentCard'] },
    ],
    RevolutionForm: [{ area: 'jss-revolution-form', label: 'Revolution form', types: [] }],
    RevolutionRegisterToNewsletterForm: [
      {
        area: 'jss-form',
        label: 'Form',
        types: [
          'GenericFormAddressField',
          'GenericFormCheckboxField',
          'GenericFormCheckboxGroup',
          'GenericFormCheckboxWithValueField',
          'GenericFormDateField',
          'GenericFormDivider',
          'GenericFormEmailInputField',
          'GenericFormHiddenConfigurationValueField',
          'GenericFormInputField',
          'GenericFormInputHiddenField',
          'GenericFormInputSelect',
          'GenericFormKVKFinderField',
          'GenericFormNameField',
          'GenericFormNumberInputField',
          'GenericFormParagraph',
          'GenericFormPhoneNumberInputField',
          'GenericFormRadioGroup',
          'GenericFormSalutationField',
          'GenericFormTextAreaInputField',
          'GenericFormUsageField',
        ],
      },
      { area: 'jss-newsletter-form-error', label: 'Newsletter form error', types: ['TitleTextCTA'] },
      { area: 'jss-newsletter-form-intro', label: 'Newsletter form intro', types: ['TitleTextCTA'] },
      { area: 'jss-newsletter-form-success', label: 'Newsletter form success', types: ['TitleTextCTA'] },
    ],
    Section: [
      {
        area: 'jss-section-main',
        label: 'Section main',
        types: [
          'Accordion',
          'Carousel',
          'Centered',
          'ChatLinks',
          'ContactCustomerService',
          'ContactMethods',
          'ContentCategories',
          'ContentHubFilter',
          'CustomerReview',
          'DynamicPricingGraph',
          'DynamicsForm',
          'EloquaForm',
          'EnergyStatisticsByRegion',
          'EnergyStatisticsForRegion',
          'FeaturePreview',
          'FlourishChart',
          'FlowNextBestActionCTA',
          'GenericForm',
          'Image',
          'LineUp',
          'List',
          'NavigationView',
          'NewsletterFormIntegratedWithRevolution',
          'NextBestActionBanner',
          'PaginatedContent',
          'PersonalizedTitleTextCTA',
          'PersonalizedVideo',
          'ProjectOverview',
          'RevolutionForm',
          'SimpleTable',
          'SplitView',
          'StepExplainer',
          'Table',
          'TextImageRebranded',
          'TitleTextCTA',
          'UsabillaFeedback',
          'Video',
          'WarmthInterruptions',
          'WeDoenHetNuTextImage',
        ],
      },
    ],
    SplitView: [
      { area: 'jss-promo-box', label: 'Promo box', types: ['PromoBox'] },
      {
        area: 'jss-split-view-first',
        label: 'Split view first',
        types: [
          'Accordion',
          'AddressFinder',
          'Carousel',
          'Checklist',
          'DynamicPriceCardElectricityV2',
          'DynamicPriceCardGasV2',
          'Image',
          'LinkCard',
          'List',
          'PersonalizedTitleTextCTA',
          'SimpleTable',
          'StepExplainer',
          'StoreButtons',
          'TitleTextCTA',
          'UsabillaFeedback',
          'Video',
          'WeDoenHetNuCard',
          'WieDoetErMeeContentCard',
        ],
      },
      {
        area: 'jss-split-view-second',
        label: 'Split view second',
        types: [
          'Accordion',
          'Carousel',
          'DynamicPriceCardElectricityV2',
          'DynamicPriceCardGasV2',
          'Image',
          'LinkCard',
          'List',
          'PersonalizedTitleTextCTA',
          'SimpleTable',
          'StepExplainer',
          'StoreButtons',
          'TitleTextCTA',
          'Video',
          'WeDoenHetNuCard',
          'WieDoetErMeeContentCard',
        ],
      },
    ],
    TitleTextCTA: [{ area: 'jss-title-text-cta-main', label: 'Title text cta main', types: ['Checklist'] }],
    WarmthInterruptions: [{ area: 'jss-interruptions-intro', label: 'Interruptions intro', types: ['TitleTextCTA'] }],
    WeDoenHetNuTextImage: [
      { area: 'jss-wedoenhetnu-text-image-main', label: 'Wedoenhetnu text image main', types: ['WeDoenHetNuCard'] },
    ],
  },
  pages: {
    articlePage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Article', 'Hero', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    b2bLeadFlowPage: [
      {
        area: 'jss-app-b2b-lead-flow',
        label: 'App b2b lead flow',
        types: [
          'B2BLeadFlowCompanyDetailsStep',
          'b2bLeadFlowNavigation',
          'B2BLeadFlowProductSelectionStep',
          'B2BLeadFlowThankYouStep',
        ],
        chrome: false,
      },
    ],
    blogOverviewPage: [{ area: 'jss-main', label: 'Main', types: ['Hero', 'Section'], chrome: false }],
    cancelationFlowPage: [
      {
        area: 'jss-app-thermostat-cancellation-flow',
        label: 'App thermostat cancellation flow',
        types: ['AccountSelectStep', 'CancelationReasonStep', 'CancelationSummaryStep', 'LogInStep', 'Navigation'],
        chrome: false,
      },
      {
        area: 'jss-app-thermostat-flow',
        label: 'App thermostat flow',
        types: [
          'AccountSelectStep',
          'LogInStep',
          'Navigation',
          'ThermostatFlowOverviewStep',
          'ThermostatFlowSuitabilityStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    categoryPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-grootzakelijk-notifications',
        label: 'Grootzakelijk notifications',
        types: ['MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    commodityCategoryPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: [
          'Chat',
          'CookieWall',
          'GTM',
          'Hotjar',
          'MetaData',
          'PersonalizationCookieController',
          'StructuredDataSchema',
          'Vwo',
        ],
        chrome: true,
      },
    ],
    commodityProductPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: [
          'Chat',
          'CookieWall',
          'GTM',
          'Hotjar',
          'MetaData',
          'PersonalizationCookieController',
          'StructuredDataSchema',
          'Vwo',
        ],
        chrome: true,
      },
    ],
    configuratorPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    contactPage: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['Chat', 'CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    contenthubBloghomePage: [{ area: 'jss-main', label: 'Main', types: [], chrome: false }],
    contenthubCategoryPage: [{ area: 'jss-main', label: 'Main', types: ['Section'], chrome: false }],
    contenthubThemePage: [{ area: 'jss-main', label: 'Main', types: ['Section'], chrome: false }],
    contractAdviceFlowPage: [
      {
        area: 'jss-app-contract-advice-flow',
        label: 'App contract advice flow',
        types: ['ContractAdviceFlowNavigation', 'MultipleChoiceStep', 'ResultStep', 'SingleChoiceStep'],
        chrome: false,
      },
    ],
    contractExtensionFlowPage: [
      { area: 'jss-app-afco-flow', label: 'App afco flow', types: [], chrome: false },
      {
        area: 'jss-app-contract-extension-flow',
        label: 'App contract extension flow',
        types: [
          'ContractExtensionDetailsStep',
          'Navigation',
          'OfferStep',
          'OxxioOfferStep',
          'OxxioSummaryStep',
          'SummaryStep',
          'SustainableChoiceStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    cvKetelKoopFlowPage: [
      {
        area: 'jss-app-cv-ketel-koop-flow',
        label: 'App cv ketel koop flow',
        types: [
          'CvKetelKoopFlowAddressStep',
          'CvKetelKoopFlowContactDetailsStep',
          'CvKetelKoopFlowNavigation',
          'CvKetelKoopFlowPersonalDetailsStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    decarbonizationLeadFlowPage: [
      {
        area: 'jss-app-decarbonization-lead-flow',
        label: 'App decarbonization lead flow',
        types: [
          'DecarbonizationLeadFlowAdditionalSuppliesStep',
          'DecarbonizationLeadFlowBuildingAreaStep',
          'DecarbonizationLeadFlowBusinessCategoriesStep',
          'DecarbonizationLeadFlowCompanyDetailsStep',
          'DecarbonizationLeadFlowNavigation',
          'DecarbonizationLeadFlowNumberOfFloorsStep',
          'DecarbonizationLeadFlowSummaryStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    deceasedFlowPage: [
      {
        area: 'jss-app-deceased-flow',
        label: 'App deceased flow',
        types: [
          'DeceasedFlowDeceaseDateStep',
          'DeceasedFlowDeceasedContactPersonDetailsStep',
          'DeceasedFlowDeceasedPersonSearchStep',
          'DeceasedFlowKeyHandoverDateStep',
          'DeceasedFlowMonthlyInstallmentPaymentMethodStep',
          'DeceasedFlowOverviewStep',
          'GenericRadioChoiceStep',
        ],
        chrome: false,
      },
    ],
    dongleFlowPage: [
      {
        area: 'jss-app-dongle-cancelation-flow',
        label: 'App dongle cancelation flow',
        types: ['CancelationSummaryStep', 'DongleCancelationReasonStep', 'Navigation'],
        chrome: false,
      },
      {
        area: 'jss-app-dongle-flow',
        label: 'App dongle flow',
        types: [
          'AccountSelectStep',
          'DongleFlowOfferStep',
          'DongleFlowSmartMeterStep',
          'DongleFlowSuitabilityStep',
          'DongleFlowSummaryStep',
          'LogInStep',
          'Navigation',
        ],
        chrome: false,
      },
    ],
    dynamicEnergyFlowPage: [
      {
        area: 'jss-app-dynamic-energy-flow',
        label: 'App dynamic energy flow',
        types: [
          'AddressDetailsStep',
          'AddressStep',
          'BuildingAgeStep',
          'BuildingTypeStep',
          'Co2UpsellStep',
          'ContactDetailsStep',
          'CrossSellRentalDeviceStep',
          'DynamicEnergyFlowNavigation',
          'EnergyChoiceStep',
          'GenericChoiceStep',
          'MeterTypeStep',
          'MovingStep',
          'NewDeliveryDateStep',
          'OverviewStep',
          'PersonalDetailsStep',
          'ResidentsStep',
          'SolarPanelsChoiceStep',
          'SolarPanelsRedeliveryStep',
          'SummaryStep',
          'UsageKnownStep',
          'UsageStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    enterpriseHomePage: [{ area: 'jss-main', label: 'Main', types: [], chrome: false }],
    heatPumpLeadFlowPage: [
      {
        area: 'jss-app-heat-pump-lead-flow',
        label: 'App heat pump lead flow',
        types: [
          'GenericRadioChoiceStep',
          'HeatPumpLeadFlowAddressStep',
          'HeatPumpLeadFlowContactDetailsStep',
          'HeatPumpLeadFlowNavigation',
          'HeatPumpLeadFlowPersonalDetailsStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    homeBatteryLeadFlowPage: [
      { area: 'jss-app-home-battery-lead-flow', label: 'App home battery lead flow', types: [], chrome: false },
    ],
    homePage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-grootzakelijk-notifications',
        label: 'Grootzakelijk notifications',
        types: ['MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-top-fixed', label: 'Top fixed', types: [], chrome: false },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    informationPage: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main (jss-main)', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      { area: 'main', label: 'Main (main)', types: [], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    ketelComfortCancelationFlowPage: [
      {
        area: 'jss-app-dongle-cancelation-flow',
        label: 'App dongle cancelation flow',
        types: ['CancelationSummaryStep', 'DongleCancelationReasonStep', 'Navigation'],
        chrome: false,
      },
      {
        area: 'jss-app-ketelcomfort-cancelation-flow',
        label: 'App ketelcomfort cancelation flow',
        types: ['CancelationSummaryStep', 'KetelComfortCancelationReasonStep', 'Navigation'],
        chrome: false,
      },
    ],
    legislationCompassFlowPage: [
      {
        area: 'jss-app-legislation-compass-flow',
        label: 'App legislation compass flow',
        types: ['GenericChoiceStep', 'LegislationStep', 'Navigation', 'QualityMarkStep'],
        chrome: false,
      },
    ],
    meterReadingsFlowPage: [
      {
        area: 'jss-app-meterreadings-flow',
        label: 'App meterreadings flow',
        types: [
          'MeterReadingsCloseDownOrYearNoteStep',
          'MeterReadingsConfirmationStep',
          'MeterReadingsMeterReadingsStep',
          'MeterReadingsReadingId',
        ],
        chrome: false,
      },
    ],
    moveOutFlowPage: [
      {
        area: 'jss-app-move-out-flow',
        label: 'App move out flow',
        types: [
          'MoveOutConfirmationStep',
          'MoveOutContactDetailsStep',
          'MoveOutDateStep',
          'MoveOutDisallowed',
          'MoveOutFlow',
          'MoveOutHeader',
        ],
        chrome: false,
      },
    ],
    myEnecoFullWidth: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: [], chrome: false },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
    ],
    myEnecoLandingPage: [
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
    ],
    myEnecoSingleColumn: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: [], chrome: false },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'Section',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
      { area: 'jss-right', label: 'Right', types: ['ChatEntryPoint'], chrome: false },
      { area: 'jss-footer-bottom', label: 'Footer bottom', types: ['Section', 'UsabillaFeedback'], chrome: true },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    myEnecoThreeColumn: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-left', label: 'Left', types: ['ProductsNavigation', 'SideNav'], chrome: false },
      { area: 'jss-main', label: 'Main', types: ['ProductsV2'], chrome: false },
      { area: 'jss-right', label: 'Right', types: ['ChatEntryPoint', 'QuickLinks'], chrome: false },
      { area: 'jss-main-bottom', label: 'Main bottom', types: [], chrome: false },
    ],
    myEnecoThreeColumnLayout: [
      { area: 'jss-left', label: 'Left', types: ['ProductsNavigation', 'SideNav'], chrome: false },
      {
        area: 'jss-main',
        label: 'Main',
        types: [
          'Accordion',
          'FlowStepIndicator',
          'MoveBillingAddressStep',
          'MoveEditMeterDetails',
          'MoveEODUpload',
          'MoveFileAddressDetails',
          'MoveFileEditAddress',
          'MoveOverviewStep',
          'MoveResidentChangeContactDetails',
          'MovingOutDateStep',
          'MyEnecoExportPaymentsAndInvoices',
          'MyEnecoInvoice',
          'ProfileManagementLoginDetails',
          'ProspectCta',
        ],
        chrome: false,
      },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
      {
        area: 'jss-right',
        label: 'Right',
        types: ['ChatEntryPoint', 'ContentCard', 'MyEnecoComfortBonus', 'MyEnecoUpcomingYearlyInvoice', 'QuickLinks'],
        chrome: false,
      },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
    ],
    myEnecoTwoColumn: [
      { area: 'jss-main', label: 'Main', types: ['Accordion', 'AccountCard', 'Bucket'], chrome: false },
      { area: 'jss-right', label: 'Right', types: ['ChatEntryPoint'], chrome: false },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'Mandate', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    myEnecoTwoColumnLayout: [
      { area: 'jss-main', label: 'Main', types: ['ProspectCta'], chrome: false },
      { area: 'jss-right', label: 'Right', types: ['ChatEntryPoint'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
    ],
    myOxxioFullWidth: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    myOxxioSingleColumn: [
      { area: 'navigation', label: 'Navigation', types: [], chrome: false },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: [], chrome: false },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    myOxxioTwoColumn: [
      { area: 'jss-main', label: 'Main', types: ['AccountCard'], chrome: false },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['Chat', 'CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    myWoonenergieSingleColumn: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: [], chrome: false },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    myWoonenergieTwoColumn: [
      { area: 'jss-main', label: 'Main', types: ['AccountCard'], chrome: false },
      { area: 'jss-right', label: 'Right', types: ['ChatEntryPoint'], chrome: false },
    ],
    myZoneFullWidth: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-dashboard-cards-featured',
        label: 'Dashboard cards featured',
        types: [
          'AccountCard',
          'AdvancePaymentAmountCard',
          'DynamicPriceCardElectricityV2',
          'DynamicPriceCardGasV2',
          'HomeProfileCard',
          'IntroductionCard',
          'InvoicesCard',
          'MandateCard',
          'MeterInErrorCard',
          'MeterreadingsCard',
          'PaymentPlanCard',
          'PromotionCard',
          'RelocationCard',
          'ServiceLinksCard',
          'UsageCard',
        ],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: [], chrome: false },
      {
        area: 'jss-no-grid',
        label: 'No grid',
        types: [
          'AccountInviteForm',
          'AccountLinkDialog',
          'AccountLinkDialogNavLink',
          'AccountOverview',
          'AdvanceNotApplicable',
          'Agreement',
          'CompanyData',
          'ContactData',
          'ContactPreferences',
          'ContactUs',
          'DashboardOverview',
          'DownloadContracts',
          'EditAdvanceAmount',
          'EditChildAccountForm',
          'EditContactData',
          'EditCrmAccountDetails',
          'EditGezinsbond',
          'EnergyMonitor',
          'EodUpload',
          'ForgotEmail',
          'ForgotEmailConfirmed',
          'ImpersonationLanding',
          'ManageAdvanceAmount',
          'MandateInformation',
          'MoveEditMeterDetails',
          'MoveFileAddressDetails',
          'MoveFileContactDetails',
          'MoveFileEditAddress',
          'MoveOnboarding',
          'MoveOutStatusIndicator',
          'MoveResidentChangeContactDetails',
          'MyEnecoComfortBonus',
          'MyEnecoEditInvoiceFrequency',
          'MyEnecoInvoice',
          'MyEnecoInvoiceBillingDetails',
          'MyEnecoInvoiceEditDueDate',
          'MyEnecoProduct',
          'MyEnecoProductDetails',
          'MyEnecoProductUpdateMeterRegime',
          'MyEnecoUpcomingYearlyInvoice',
          'MyEnecoUpdateInvoicePaymentMethod',
          'Orders',
          'OrdersDashboard',
          'PaymentPlanOnboarding',
          'PriceSimulation',
          'ProductSwitch',
          'ProfileManagementLoginDetails',
          'ProfileManagementLoginDetailsConfirmEmail',
          'ProfileManagementLoginDetailsLinkItsme',
          'ProfileManagementLoginDetailsUpdate',
          'ProfileMenuBe',
          'ProjectOverviewWind',
          'ProjectOverviewWindItems',
          'ProjectWindData',
          'ProjectWindHeroCard',
          'ProjectWindMap',
          'ProspectCta',
          'RequestVacancy',
          'SelectMoveReason',
          'SmartTargetingBanner',
          'UsageCapMonthView',
          'UsageCapYearnoteView',
        ],
        chrome: false,
      },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: [
          'Chat',
          'CookieWall',
          'GTM',
          'Hotjar',
          'MetaData',
          'PersonalizationCookieController',
          'StructuredDataSchema',
          'Vwo',
        ],
        chrome: true,
      },
    ],
    newEnergyFlowPage: [
      {
        area: 'jss-app-dynamic-energy-flow',
        label: 'App dynamic energy flow',
        types: [
          'AddressDetailsStep',
          'AddressStep',
          'BuildingAgeStep',
          'BuildingTypeStep',
          'Co2UpsellStep',
          'ContactDetailsStep',
          'CrossSellRentalDeviceStep',
          'DynamicEnergyFlowNavigation',
          'EnergyChoiceStep',
          'GenericChoiceStep',
          'MeterTypeStep',
          'MovingStep',
          'NewDeliveryDateStep',
          'OverviewStep',
          'PersonalDetailsStep',
          'ResidentsStep',
          'SolarPanelsChoiceStep',
          'SolarPanelsRedeliveryStep',
          'SummaryStep',
          'UsageKnownStep',
          'UsageStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-app-energy-flow',
        label: 'App energy flow',
        types: [
          'AddressDetailsStep',
          'AddressStep',
          'BuildingAgeStep',
          'BuildingTypeStep',
          'Co2UpsellStep',
          'ContactDetailsStep',
          'CrossSellRentalDeviceStep',
          'EnergyChoiceStep',
          'GenericChoiceStep',
          'LineUp',
          'MeterTypeStep',
          'MovingStep',
          'Navigation',
          'NewDeliveryDateStep',
          'OverviewStep',
          'OxxioNewDeliveryDateStep',
          'OxxioOfferStep',
          'OxxioOverviewStep',
          'OxxioSummaryStep',
          'PersonalDetailsStep',
          'ResidentsStep',
          'SolarPanelsChoiceStep',
          'SolarPanelsRedeliveryStep',
          'SummaryStep',
          'SustainableChoiceStep',
          'UsageKnownStep',
          'UsageStep',
        ],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: [], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    pageChrome: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: false,
      },
      { area: 'jss-footer-bottom', label: 'Footer bottom', types: ['Section', 'UsabillaFeedback'], chrome: false },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: false,
      },
    ],
    paymentArrangementFlowPage: [
      {
        area: 'jss-app-payment-arrangement-flow',
        label: 'App payment arrangement flow',
        types: [
          'PaymentArrangement',
          'PaymentArrangementConfirmStep',
          'PaymentArrangementEndStep',
          'PaymentArrangementHeader',
          'PaymentArrangementInvoicesStep',
          'PaymentArrangementStartDateStep',
          'PaymentArrangementTermsStep',
        ],
        chrome: false,
      },
    ],
    productPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-grootzakelijk-notifications',
        label: 'Grootzakelijk notifications',
        types: ['MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-main',
        label: 'Main',
        types: ['DynamicPricingTariffs', 'Hero', 'HeroRebranded', 'Section'],
        chrome: false,
      },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['Chat', 'CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    projectOverviewPage: [{ area: 'jss-main', label: 'Main', types: [], chrome: false }],
    registrationPage: [
      { area: 'jss-header', label: 'Header', types: ['RegistrationHeader'], chrome: false },
      {
        area: 'jss-main',
        label: 'Main',
        types: ['RegistrationAccountCreate', 'RegistrationAccountReset'],
        chrome: false,
      },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'RegistrationFooter', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    relocationFlowPage: [
      {
        area: 'jss-app-relocation-flow',
        label: 'App relocation flow',
        types: [
          'RelocationConfirmationStep',
          'RelocationContactDetailsStep',
          'RelocationDisallowed',
          'RelocationFlow',
          'RelocationHeader',
          'RelocationMoveInStep',
          'RelocationMoveOutStep',
          'RelocationNewAddressStep',
        ],
        chrome: false,
      },
    ],
    rentalDevicesFlowPage: [
      {
        area: 'jss-app-rental-devices-flow',
        label: 'App rental devices flow',
        types: [
          'AddressStep',
          'ContactDetailsStep',
          'GenericChoiceStep',
          'Navigation',
          'PersonalDetailsStep',
          'RentalDevicesDetectionStep',
          'RentalDevicesOverviewStep',
          'RentalDevicesSummaryStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    serviceContentPage: [
      {
        area: 'jss-grootzakelijk-notifications',
        label: 'Grootzakelijk notifications',
        types: ['MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    serviceGemakFlowPage: [
      {
        area: 'jss-app-servicegemak-flow',
        label: 'App servicegemak flow',
        types: [
          'AddressStep',
          'GenericCheckboxChoiceStep',
          'GenericChoiceStep',
          'GenericRadioChoiceStep',
          'KetelComfortPersonalDetailsStep',
          'ServiceGemakFlowBoilerBrandStep',
          'ServiceGemakFlowBoilerReachabilityStep',
          'ServiceGemakFlowContact',
          'ServiceGemakFlowNavigation',
          'ServiceGemakFlowOfferStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    serviceHomePage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-grootzakelijk-notifications',
        label: 'Grootzakelijk notifications',
        types: ['MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Chat', 'Hero', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    serviceMalfunctionPage: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Section'], chrome: false },
    ],
    serviceProcessPage: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Section'], chrome: false },
    ],
    smeEnergyFlowPage: [
      {
        area: 'jss-app-sme-energy-flow-v2',
        label: 'App sme energy flow v2',
        types: [
          'GenericChoiceStep',
          'Navigation',
          'OverviewStep',
          'SMEAddressStep',
          'SmeCompanyDetailsStep',
          'SmeOfferStep',
          'SmeSolarPanelsStep',
          'SmeUsageStep',
        ],
        chrome: false,
      },
    ],
    smeEnergyFlowPageLegacy: [
      {
        area: 'jss-app-sme-energy-flow-v2',
        label: 'App sme energy flow v2',
        types: [
          'GenericChoiceStep',
          'Navigation',
          'OverviewStep',
          'SMEAddressStep',
          'SmeCompanyDetailsStep',
          'SmeOfferStep',
          'SmeSolarPanelsStep',
          'SmeUsageStep',
        ],
        chrome: false,
      },
    ],
    sohoHomePage: [{ area: 'jss-main', label: 'Main', types: [], chrome: false }],
    solarBoilerLeadFlowPage: [
      {
        area: 'jss-app-solar-boiler-lead-flow',
        label: 'App solar boiler lead flow',
        types: [
          'GenericRadioChoiceStep',
          'SolarBoilerLeadFlowAddressStep',
          'SolarBoilerLeadFlowContactDetailsStep',
          'SolarBoilerLeadFlowNavigation',
          'SolarBoilerLeadFlowPersonalDetailsStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    standardContentPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-grootzakelijk-notifications',
        label: 'Grootzakelijk notifications',
        types: ['MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-header', label: 'Header', types: [], chrome: false },
      { area: 'jss-top-fixed', label: 'Top fixed', types: ['TopBar'], chrome: false },
      {
        area: 'jss-main',
        label: 'Main',
        types: [
          'Accordion',
          'BottomNavigationsButtons',
          'HEMSMinimalNavigationBar',
          'Hero',
          'HeroRebranded',
          'IconLink',
          'InspirationAdviceFilter',
          'MandateWarning',
          'PageTitle',
          'PageTitlePremium',
          'ProductPurchaseFlow',
          'RichText',
          'Section',
          'SmartChargingCompatibilityCheckResult',
          'Unsubscribe',
        ],
        chrome: false,
      },
      { area: 'jss-bottom-fixed', label: 'Bottom fixed', types: ['BottomMenu'], chrome: false },
      { area: 'jss-main-bottom', label: 'Main bottom', types: [], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: [
          'Chat',
          'CookieWall',
          'GTM',
          'Hotjar',
          'MetaData',
          'PersonalizationCookieController',
          'StructuredDataSchema',
          'Vwo',
        ],
        chrome: true,
      },
    ],
    tariffCardPage: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
    ],
    thankYouPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    thermostatCancellationFlowPage: [
      {
        area: 'jss-app-thermostat-cancellation-flow',
        label: 'App thermostat cancellation flow',
        types: ['AccountSelectStep', 'CancelationReasonStep', 'CancelationSummaryStep', 'LogInStep', 'Navigation'],
        chrome: false,
      },
    ],
    thermostatFlowPage: [
      {
        area: 'jss-app-thermostat-flow',
        label: 'App thermostat flow',
        types: [
          'AccountSelectStep',
          'LogInStep',
          'Navigation',
          'ThermostatFlowOfferStep',
          'ThermostatFlowOverviewStep',
          'ThermostatFlowSuitabilityStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    toonCancelationFlowPage: [
      {
        area: 'jss-app-toon-cancelation-flow',
        label: 'App toon cancelation flow',
        types: ['CancelationSummaryStep', 'Navigation', 'ToonCancelationReasonStep'],
        chrome: false,
      },
      { area: 'jss-app-toon-cancellation-flow', label: 'App toon cancellation flow', types: [], chrome: false },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    toonFlowPage: [
      {
        area: 'jss-app-toon-flow',
        label: 'App toon flow',
        types: [
          'AddressStep',
          'ContactDetailsStep',
          'GenericChoiceStep',
          'MeterTypeStep',
          'Navigation',
          'PersonalDetailsStep',
          'SolarPanelsChoiceStep',
          'ToonOfferStep',
          'ToonOverviewStep',
          'ToonSummaryStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    toonReplacementFlowPage: [
      {
        area: 'jss-app-toon-replacement-flow',
        label: 'App toon replacement flow',
        types: [
          'AddressStep',
          'ContactDetailsStep',
          'GenericChoiceStep',
          'MeterTypeStep',
          'Navigation',
          'PersonalDetailsStep',
          'SolarPanelsChoiceStep',
          'ToonOfferStep',
          'ToonOverviewStep',
          'ToonSummaryStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    toonSubscriptionFlowPage: [
      {
        area: 'jss-app-toon-subscription-flow',
        label: 'App toon subscription flow',
        types: [
          'AddressStep',
          'ContactDetailsStep',
          'GenericChoiceStep',
          'MeterTypeStep',
          'Navigation',
          'PersonalDetailsStep',
          'SolarPanelsChoiceStep',
          'ToonOfferStep',
          'ToonOverviewStep',
          'ToonSummaryStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    topicExtendedPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['HeroRebranded', 'Section'], chrome: false },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: [
          'Chat',
          'CookieWall',
          'GTM',
          'Hotjar',
          'MetaData',
          'PersonalizationCookieController',
          'StructuredDataSchema',
          'Vwo',
        ],
        chrome: true,
      },
    ],
    topicSimplePage: [{ area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false }],
    urgentEnergyFlowPage: [
      {
        area: 'jss-app-energy-flow',
        label: 'App energy flow',
        types: [
          'AddressDetailsStep',
          'AddressStep',
          'BuildingAgeStep',
          'BuildingTypeStep',
          'Co2UpsellStep',
          'ContactDetailsStep',
          'CrossSellRentalDeviceStep',
          'EnergyChoiceStep',
          'GenericChoiceStep',
          'LineUp',
          'MeterTypeStep',
          'MovingStep',
          'Navigation',
          'NewDeliveryDateStep',
          'OverviewStep',
          'OxxioNewDeliveryDateStep',
          'OxxioOfferStep',
          'OxxioOverviewStep',
          'OxxioSummaryStep',
          'PersonalDetailsStep',
          'ResidentsStep',
          'SolarPanelsChoiceStep',
          'SolarPanelsRedeliveryStep',
          'SummaryStep',
          'SustainableChoiceStep',
          'UsageKnownStep',
          'UsageStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-app-urgent-energy-flow',
        label: 'App urgent energy flow',
        types: [
          'AddressDetailsStep',
          'AddressStep',
          'BuildingAgeStep',
          'BuildingTypeStep',
          'Co2UpsellStep',
          'ContactDetailsStep',
          'DeliveryDateStep',
          'DeliveryDateStepUrgentOxxio',
          'EnergyChoiceStep',
          'LineUp',
          'MeterTypeStep',
          'Navigation',
          'OverviewStep',
          'PersonalDetailsStep',
          'ResidentsStep',
          'SituationStep',
          'SolarPanelsChoiceStep',
          'SolarPanelsRedeliveryStep',
          'SummaryStep',
          'UsageKnownStep',
          'UsageStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
    vasCategoryPage: [{ area: 'jss-main', label: 'Main', types: ['Section'], chrome: false }],
    vasProductPage: [
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      { area: 'jss-main', label: 'Main', types: ['Hero', 'HeroRebranded', 'Section'], chrome: false },
    ],
    windHomePage: [{ area: 'jss-main', label: 'Main', types: [], chrome: false }],
    windProjectPage: [
      { area: 'jss-navigationbar', label: 'Navigation bar', types: ['MainNavigation'], chrome: true },
      {
        area: 'jss-notifications',
        label: 'Notifications',
        types: ['CreditWarningBar', 'MessageBar', 'NotificationsBar'],
        chrome: false,
      },
      {
        area: 'jss-main',
        label: 'Main',
        types: ['HeroRebranded', 'ProjectWindData', 'ProjectWindMap', 'Section'],
        chrome: false,
      },
      {
        area: 'jss-footer',
        label: 'Footer',
        types: ['Accordion', 'AccountLinkDialog', 'Centered', 'Footer', 'Section'],
        chrome: true,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: [
          'Chat',
          'CookieWall',
          'GTM',
          'Hotjar',
          'MetaData',
          'PersonalizationCookieController',
          'StructuredDataSchema',
          'Vwo',
        ],
        chrome: true,
      },
    ],
    zonOpToonFlowPage: [
      {
        area: 'jss-app-zon-op-toon-flow',
        label: 'App zon op toon flow',
        types: [
          'AddressStep',
          'ContactDetailsStep',
          'GenericChoiceStep',
          'MeterTypeStep',
          'Navigation',
          'PersonalDetailsStep',
          'SolarPanelsChoiceStep',
          'ToonOfferStep',
          'ToonOverviewStep',
          'ToonSummaryStep',
        ],
        chrome: false,
      },
      {
        area: 'jss-meta',
        label: 'Meta',
        types: ['CookieWall', 'GTM', 'MetaData', 'PersonalizationCookieController', 'StructuredDataSchema'],
        chrome: true,
      },
    ],
  },
  typesWithTitle: [
    'Accordion',
    'AccountLinkDialog',
    'AccountOverview',
    'AddressDetailsStep',
    'AddressStep',
    'AdvanceNotApplicable',
    'AdvancePaymentAmountCard',
    'Agreement',
    'Article',
    'B2BLeadFlowCompanyDetailsStep',
    'B2BLeadFlowProductSelectionStep',
    'B2BLeadFlowThankYouStep',
    'Bucket',
    'BuildingAgeStep',
    'BuildingTypeStep',
    'CancelationReasonStep',
    'ChatLinks',
    'Co2UpsellStep',
    'CompanyData',
    'ContactCustomerService',
    'ContactData',
    'ContactForm',
    'ContactMethods',
    'ContentCard',
    'ContentCardRebranded',
    'ContentCategories',
    'ContentHubFilter',
    'ContractRenewedCard',
    'CookieWall',
    'CrossSellRentalDeviceStep',
    'CustomerReview',
    'CvKetelKoopFlowAddressStep',
    'CvKetelKoopFlowPersonalDetailsStep',
    'DecarbonizationLeadFlowAdditionalSuppliesStep',
    'DecarbonizationLeadFlowBuildingAreaStep',
    'DecarbonizationLeadFlowBusinessCategoriesStep',
    'DecarbonizationLeadFlowCompanyDetailsStep',
    'DecarbonizationLeadFlowNumberOfFloorsStep',
    'DeceasedFlowDeceaseDateStep',
    'DeceasedFlowDeceasedContactPersonDetailsStep',
    'DeceasedFlowDeceasedPersonSearchStep',
    'DeceasedFlowKeyHandoverDateStep',
    'DeliveryDateStep',
    'DeliveryDateStepUrgentOxxio',
    'DongleCancelationReasonStep',
    'DongleFlowSuitabilityStep',
    'DownloadContracts',
    'DynamicPriceCardElectricityV2',
    'DynamicPriceCardGasV2',
    'DynamicPricingGraph',
    'DynamicPricingTariffs',
    'EditAdvanceAmount',
    'EditContactData',
    'EloquaForm',
    'EnergyChoiceStep',
    'EnergyMonitor',
    'EodUpload',
    'FlowStepIndicator',
    'ForgotEmail',
    'ForgotEmailConfirmed',
    'GenericForm',
    'HeatPumpLeadFlowAddressStep',
    'HeatPumpLeadFlowPersonalDetailsStep',
    'HeatPumpSpecTable',
    'HeroCard',
    'HeroCardRebranded',
    'HomeProfileCard',
    'IconList',
    'ImpersonationLanding',
    'KetelComfortCancelationReasonStep',
    'LegislationStep',
    'LinkCard',
    'List',
    'LogInStep',
    'MainMenu',
    'Mandate',
    'MandateCard',
    'MandateInformation',
    'MegaMenu',
    'MegaMenuDivision',
    'MegaMenuV2',
    'MessageBar',
    'MeterInErrorCard',
    'MeterTypeStep',
    'MeterreadingsCard',
    'MoveEditMeterDetails',
    'MoveFileEditAddress',
    'MoveOutContactDetailsStep',
    'MoveOutDateStep',
    'MoveOutHeader',
    'MoveOutStatusIndicator',
    'MoveOverviewStep',
    'MovingStep',
    'MultipleChoiceStep',
    'MyEnecoEditInvoiceFrequency',
    'MyEnecoExportPaymentsAndInvoices',
    'MyEnecoInvoice',
    'MyEnecoInvoiceEditDueDate',
    'MyEnecoProduct',
    'MyEnecoProductUpdateMeterRegime',
    'MyEnecoUpcomingYearlyInvoice',
    'MyEnecoUpdateInvoicePaymentMethod',
    'NewDeliveryDateStep',
    'NextBestActionBanner',
    'Orders',
    'OrdersDashboard',
    'OxxioNewDeliveryDateStep',
    'PaymentArrangementEndStep',
    'PaymentArrangementInvoicesStep',
    'PaymentArrangementStartDateStep',
    'PaymentArrangementTermsStep',
    'PaymentPlanCard',
    'PersonalDetailsStep',
    'PersonalizedTitleTextCTA',
    'PersonalizedVideo',
    'ProjectOverview',
    'ProjectOverviewWind',
    'ProjectWindData',
    'ProjectWindMap',
    'PromoBox',
    'PromotionCard',
    'QualityMarkStep',
    'QuickLinks',
    'RelocationCard',
    'RelocationContactDetailsStep',
    'RelocationHeader',
    'RelocationMoveInStep',
    'RelocationMoveOutStep',
    'RelocationNewAddressStep',
    'RequestVacancy',
    'ResidentsStep',
    'ResultStep',
    'RevolutionForm',
    'SMEAddressStep',
    'SearchChatBot',
    'SelectMoveReason',
    'ServiceGemakFlowBoilerBrandStep',
    'ServiceGemakFlowBoilerReachabilityStep',
    'ServiceGemakFlowContact',
    'ServiceGemakFlowOfferStep',
    'SimpleTable',
    'SingleChoiceStep',
    'SituationStep',
    'SmartTargetingBanner',
    'SmeUsageStep',
    'SocialMediaMenu',
    'SolarBoilerLeadFlowAddressStep',
    'SolarBoilerLeadFlowPersonalDetailsStep',
    'SolarPanelsChoiceStep',
    'SolarPanelsRedeliveryStep',
    'StepExplainer',
    'StoreButtons',
    'SubFooterMenu',
    'SubMenu',
    'SustainableChoiceStep',
    'Table',
    'TextImageRebranded',
    'TextStreamer',
    'ThermostatFlowSuitabilityStep',
    'TitleTextCTA',
    'ToonCancelationReasonStep',
    'ToonOverviewStep',
    'TopTaskCTA',
    'USPItem',
    'UsageCapMonthView',
    'UsageCapYearnoteView',
    'UsageCard',
    'UsageKnownStep',
    'UsageStep',
  ],
};
